import { render, staticRenderFns } from "./EvolucaoQuantidadeCliente.vue?vue&type=template&id=8aa79148&scoped=true&"
import script from "./EvolucaoQuantidadeCliente.vue?vue&type=script&lang=js&"
export * from "./EvolucaoQuantidadeCliente.vue?vue&type=script&lang=js&"
import style0 from "./EvolucaoQuantidadeCliente.vue?vue&type=style&index=0&id=8aa79148&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8aa79148",
  null
  
)

export default component.exports